import { render, staticRenderFns } from "./ProfileDeactivateForms.vue?vue&type=template&id=7b0d962f&"
import script from "./ProfileDeactivateForms.vue?vue&type=script&lang=js&"
export * from "./ProfileDeactivateForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports